// src/components/layout/Footer.tsx
import { Box, Typography, Link } from '@mui/material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#1B2B3A',
        color: '#FFFFFF',
        py: 2,
        px: 4,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        mt: 'auto'
      }}
    >
      <Typography variant="body2" sx={{ color: '#FFFFFF' }}>
        Phriendly Phishing Copyright © {currentYear}
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Link 
          href="https://www.linkedin.com/company/phriendlyphishing/"
          target="_blank" 
          rel="noopener"
          sx={{ 
            color: '#FFFFFF',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          LinkedIn
        </Link>
        <Typography>|</Typography>
        <Link 
          href="https://twitter.com/phriendlyphish"
          target="_blank" 
          rel="noopener"
          sx={{ 
            color: '#FFFFFF',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          Twitter
        </Link>
      </Box>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Link 
          href="https://www.phriendlyphishing.com/privacy-policy"
          target="_blank"
          rel="noopener"
          sx={{ 
            color: '#FFFFFF',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          Privacy Policy
        </Link>
        <Typography>|</Typography>
        <Link 
          href="https://www.phriendlyphishing.com/terms-conditions"
          target="_blank"
          rel="noopener"
          sx={{ 
            color: '#FFFFFF',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          Terms and Conditions
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;
